import { t } from 'i18next';
import React from 'react';
import {
  StudyContainer,
  StudyDate,
  StudyDateTime,
  StudyField,
  StudyHeader,
  StudyHeaderField,
  StudyList,
  StudyRow,
  StudyTime,
  StudyValue } from '../styled/PatientHistory';
import store from '../../../../store/store';

export const StudiesInfo = ({ studies, handleClick }) => {
  const { config } = store.getState();
  const { PACS_SELECTOR_CONFIG: datasource } = config;

  const getPacs = (location) => datasource.find(({ id }) => id === location);

  return (
    <StudyContainer>
      <StudyHeader>
        <StudyHeaderField>{t('studiesTable.accessionnumber')}</StudyHeaderField>
        <StudyHeaderField>{t('study.description')}</StudyHeaderField>
        <StudyHeaderField>{t('study.date')}</StudyHeaderField>
        <StudyHeaderField>Location</StudyHeaderField>
        <StudyHeaderField>{t('pacs.server')}</StudyHeaderField>
      </StudyHeader>
      <StudyList>
        {studies.map((study) => (
          <StudyRow key={study.StudyInstanceUID} onClick={() => handleClick(study)}>
            <StudyField>
              <StudyValue>{study.AccessionNumber || '—'}</StudyValue>
            </StudyField>
            <StudyField>
              <StudyValue>{study.StudyDescription || '—'}</StudyValue>
            </StudyField>
            <StudyField>
              <StudyDateTime>
                <StudyDate>{study.StudyDate || '—'}</StudyDate>
                {study.StudyTime && <StudyTime>{study.StudyTime}</StudyTime>}
              </StudyDateTime>
            </StudyField>
            <StudyField>
              <StudyValue>{study.Location || '—'}</StudyValue>
            </StudyField>
            <StudyField>
              <StudyValue>{getPacs(study.Location)?.name || '—'}</StudyValue>
            </StudyField>
          </StudyRow>
        ))}
      </StudyList>
    </StudyContainer>
  );
};
export default StudiesInfo;
